module.exports = __webpack_public_path__ + "static/media/car_key.292bd50b.jpg";